import React, { Fragment } from 'react'
import { Chapter } from '../drilldown-content-view'
import { MustacheRenderer } from '../../../../legacy-design-system/mustache'
import { css } from '@emotion/css'
import { theme } from '../../../../styled'

interface ChapterViewProps {
  readonly chapter: Chapter
}

export function MustacheChapterView({ chapter }: ChapterViewProps) {
  return (
    <div>
      {chapter.introText && <ChapterIntroText introText={chapter.introText} />}
      {chapter.body && <ChapterBody chapter={chapter} />}
    </div>
  )
}

function ChapterBody({ chapter }) {
  return (
    <Fragment>
      <div
        className={`well evidence-well break-word 
        ${css`
          font-family: ${theme.fontFamilies.code};
        `}`}
      >
        <MustacheRenderer tagName="span" template={chapter.body} />
      </div>
    </Fragment>
  )
}

function ChapterIntroText({ introText }: { readonly introText?: string }) {
  if (introText) {
    return (
      <div>
        <MustacheRenderer tagName="span" template={introText} />
      </div>
    )
  }
  return null
}
